import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { RouteEnum } from "core/enum/route.enum";
import { getRedirectUrl, removeRedirectUrl } from "core/services/auth/auth";
import { SuccessToast } from "core/utils/show-toast";
import { AppDispatch } from "store";
import { handleLoginCallback } from "store/auth/auth.thunks";
import { ComponentSpinner } from "../../common/Spinner/LoadingSpinner";

const SigninOidc: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const signInProcess = async () => {
      try {
        await dispatch(handleLoginCallback()).unwrap();

        const redirectUrl = getRedirectUrl() || "/";
        removeRedirectUrl();

        history.replace(redirectUrl);

        SuccessToast(["خوش آمدید!"]);
      } catch (err) {
        console.error(err);

        history.replace(RouteEnum.Login);
      }
    };

    signInProcess();
  }, []);

  return <ComponentSpinner />;
};

export { SigninOidc };
